module.exports = __webpack_public_path__ + "static/samegrain_banner-22ffb42a6d084138a1f9f42f879a7f75.png";